import React from "react";
import NewsletterEighteen from "../component/NewsletterEighteen";

function NewsletterEighteenContainer() {
  return <NewsletterEighteen />;
}

export default NewsletterEighteenContainer;
